var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseSolidIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 10A5 5 0 1 1 5 0a5 5 0 0 1 0 10m0-5.707L3.586 2.879l-.707.707L4.293 5 2.879 6.414l.707.707L5 5.707l1.414 1.414.707-.707L5.707 5l1.414-1.414-.707-.707z"
})));
export { SvgCloseSolidIcon as ReactComponent };
export default __webpack_public_path__ + "287eb66617025656f0ede540049eb3ff.svg";